import * as Crypto from "expo-crypto";
import * as SecureStore from "expo-secure-store";
import { Platform } from "react-native";

const INSTALLATION_ID_KEY = "push.installation_id";

/**
 * Stable per-install UUID used to upsert push-device rows on s4p.
 */
export async function getOrCreateInstallationId(): Promise<string> {
    if (Platform.OS === "web") {
        return "web";
    }

    const existing = await SecureStore.getItemAsync(INSTALLATION_ID_KEY);
    if (existing) {
        return existing;
    }

    const created = Crypto.randomUUID();
    await SecureStore.setItemAsync(INSTALLATION_ID_KEY, created);
    return created;
}
